/** Auto-generated by scripts/bootstrap-viewer-i18n.mjs — do not edit manually */
export type ViewerStringKey = 'digitalProductPassport' | 'language' | 'selectLanguage' | 'productIdentifiers' | 'productId' | 'operatorId' | 'facilityId' | 'dppRegistrationId' | 'documents' | 'lastUpdated' | 'poweredBy' | 'mandatory' | 'voluntary' | 'productDetails' | 'technicalSpecifications' | 'sustainabilityInformation' | 'complianceCertifications' | 'materialComposition' | 'loading' | 'notFound' | 'failedToLoad' | 'publicDpp' | 'sku' | 'category' | 'uniqueId' | 'published' | 'productDescription' | 'downloadableDocuments' | 'yes' | 'no' | 'open' | 'noDocuments' | 'noComplianceCerts' | 'material' | 'type' | 'percentage' | 'weight' | 'origin' | 'certificate' | 'number' | 'authority' | 'expires' | 'organisationLogo' | 'skipToContent' | 'name' | 'size' | 'download';

export const VIEWER_STRINGS: Record<string, Record<ViewerStringKey, string>> = {
  "bg": {
    "digitalProductPassport": "Цифров паспорт на продукта",
    "language": "Български",
    "selectLanguage": "Български — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Документи",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Задължително (регулация)",
    "voluntary": "Доброволно",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Към основното съдържание",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "cs": {
    "digitalProductPassport": "Digitální produktový pas",
    "language": "Čeština",
    "selectLanguage": "Čeština — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Dokumenty",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Povinné (regulace)",
    "voluntary": "Dobrovolné",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Přejít na hlavní obsah",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "da": {
    "digitalProductPassport": "Digital produktpas",
    "language": "Dansk",
    "selectLanguage": "Dansk — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Dokumenter",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Obligatorisk (regulering)",
    "voluntary": "Frivillig",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Spring til hovedindhold",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "de": {
    "digitalProductPassport": "Digitaler Produktpass",
    "language": "Deutsch",
    "selectLanguage": "Deutsch — Select passport language",
    "productIdentifiers": "Produktkennungen",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Dokumente",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Pflicht (regulatorisch)",
    "voluntary": "Freiwillig",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Produktpass wird geladen…",
    "notFound": "Produktpass nicht gefunden",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Zum Hauptinhalt springen",
    "name": "Name",
    "size": "Größe",
    "download": "Download"
  },
  "el": {
    "digitalProductPassport": "Ψηφιακό διαβατήριο προϊόντος",
    "language": "Ελληνικά",
    "selectLanguage": "Ελληνικά — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Έγγραφα",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Υποχρεωτικό (ρυθμιστικό)",
    "voluntary": "Εθελοντικό",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Μετάβαση στο κύριο περιεχόμενο",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "en": {
    "digitalProductPassport": "Digital Product Passport",
    "language": "English",
    "selectLanguage": "English — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Documents",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Mandatory (regulatory)",
    "voluntary": "Voluntary",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Skip to main content",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "es": {
    "digitalProductPassport": "Pasaporte digital del producto",
    "language": "Español",
    "selectLanguage": "Español — Select passport language",
    "productIdentifiers": "Identificadores del producto",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Documentos",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Obligatorio (regulatorio)",
    "voluntary": "Voluntario",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Ir al contenido principal",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "et": {
    "digitalProductPassport": "Digitaalne tootepass",
    "language": "Eesti",
    "selectLanguage": "Eesti — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Dokumendid",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Kohustuslik (regulatsioon)",
    "voluntary": "Vabatahtlik",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Liigu põhisisu juurde",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "fi": {
    "digitalProductPassport": "Digitaalinen tuotepassi",
    "language": "Suomi",
    "selectLanguage": "Suomi — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Asiakirjat",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Pakollinen (sääntely)",
    "voluntary": "Vapaaehtoinen",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Siirry pääsisältöön",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "fr": {
    "digitalProductPassport": "Passeport numérique du produit",
    "language": "Français",
    "selectLanguage": "Français — Select passport language",
    "productIdentifiers": "Identifiants produit",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Documents",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Obligatoire (réglementaire)",
    "voluntary": "Volontaire",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Chargement du passeport…",
    "notFound": "Passeport produit introuvable",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Aller au contenu principal",
    "name": "Nom",
    "size": "Taille",
    "download": "Télécharger"
  },
  "ga": {
    "digitalProductPassport": "Pas Éireannach Digiteach Táirge",
    "language": "Gaeilge",
    "selectLanguage": "Gaeilge — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Doiciméid",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Éigeantach (rialáil)",
    "voluntary": "Deonach",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Léim go dtí an príomhábhar",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "hr": {
    "digitalProductPassport": "Digitalni pasoš proizvoda",
    "language": "Hrvatski",
    "selectLanguage": "Hrvatski — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Dokumenti",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Obavezno (regulativa)",
    "voluntary": "Dobrovoljno",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Preskoči na sadržaj",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "hu": {
    "digitalProductPassport": "Digitális termékútlevél",
    "language": "Magyar",
    "selectLanguage": "Magyar — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Dokumentumok",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Kötelező (szabályozás)",
    "voluntary": "Önkéntes",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Ugrás a fő tartalomhoz",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "it": {
    "digitalProductPassport": "Passaporto digitale del prodotto",
    "language": "Italiano",
    "selectLanguage": "Italiano — Select passport language",
    "productIdentifiers": "Identificativi prodotto",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Documenti",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Obbligatorio (normativo)",
    "voluntary": "Volontario",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Vai al contenuto principale",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "lt": {
    "digitalProductPassport": "Skaitmeninis produkto pasas",
    "language": "Lietuvių",
    "selectLanguage": "Lietuvių — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Dokumentai",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Privaloma (reguliavimas)",
    "voluntary": "Savanoriška",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Pereiti prie turinio",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "lv": {
    "digitalProductPassport": "Digitālais produkta pase",
    "language": "Latviešu",
    "selectLanguage": "Latviešu — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Dokumenti",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Obligāts (regulējums)",
    "voluntary": "Brīvprātīgs",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Pāriet uz saturu",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "mt": {
    "digitalProductPassport": "Passaport digitali tal-prodott",
    "language": "Malti",
    "selectLanguage": "Malti — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Dokumenti",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Obbligatorju (regolamentar)",
    "voluntary": "Volontarju",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Aqbeż għall-kontenut prinċipali",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "nl": {
    "digitalProductPassport": "Digitaal productpaspoort",
    "language": "Nederlands",
    "selectLanguage": "Nederlands — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Documenten",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Verplicht (regelgeving)",
    "voluntary": "Vrijwillig",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Ga naar hoofdinhoud",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "pl": {
    "digitalProductPassport": "Cyfrowy paszport produktu",
    "language": "Polski",
    "selectLanguage": "Polski — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Dokumenty",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Obowiązkowe (regulacyjne)",
    "voluntary": "Dobrowolne",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Przejdź do treści",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "pt": {
    "digitalProductPassport": "Passaporte digital do produto",
    "language": "Português",
    "selectLanguage": "Português — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Documentos",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Obrigatório (regulamentar)",
    "voluntary": "Voluntário",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Ir para o conteúdo principal",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "ro": {
    "digitalProductPassport": "Pașaport digital al produsului",
    "language": "Română",
    "selectLanguage": "Română — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Documente",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Obligatoriu (reglementar)",
    "voluntary": "Voluntar",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Salt la conținutul principal",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "sk": {
    "digitalProductPassport": "Digitálny produktový pas",
    "language": "Slovenčina",
    "selectLanguage": "Slovenčina — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Dokumenty",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Povinné (regulácia)",
    "voluntary": "Dobrovoľné",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Preskočiť na hlavný obsah",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "sl": {
    "digitalProductPassport": "Digitalni potni list izdelka",
    "language": "Slovenščina",
    "selectLanguage": "Slovenščina — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Dokumenti",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Obvezno (regulativa)",
    "voluntary": "Prostovoljno",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Preskoči na vsebino",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  },
  "sv": {
    "digitalProductPassport": "Digital produktpass",
    "language": "Svenska",
    "selectLanguage": "Svenska — Select passport language",
    "productIdentifiers": "Product Identifiers",
    "productId": "Product ID",
    "operatorId": "Operator ID",
    "facilityId": "Facility ID",
    "dppRegistrationId": "DPP Registration ID",
    "documents": "Dokument",
    "lastUpdated": "Last updated",
    "poweredBy": "Powered by DPPConnect.io",
    "mandatory": "Obligatorisk (reglering)",
    "voluntary": "Frivillig",
    "productDetails": "Product Details",
    "technicalSpecifications": "Technical Specifications",
    "sustainabilityInformation": "Sustainability Information",
    "complianceCertifications": "Compliance & Certifications",
    "materialComposition": "Material Composition",
    "loading": "Loading product passport…",
    "notFound": "Product passport not found",
    "failedToLoad": "Failed to load product passport",
    "publicDpp": "Public DPP",
    "sku": "SKU",
    "category": "Category",
    "uniqueId": "Unique ID",
    "published": "Published",
    "productDescription": "Product Description",
    "downloadableDocuments": "Downloadable Documents",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "noDocuments": "No public documents available.",
    "noComplianceCerts": "No compliance certificates provided.",
    "material": "Material",
    "type": "Type",
    "percentage": "Percentage",
    "weight": "Weight",
    "origin": "Origin",
    "certificate": "Certificate",
    "number": "Number",
    "authority": "Authority",
    "expires": "Expires",
    "organisationLogo": "Organisation logo",
    "skipToContent": "Hoppa till huvudinnehåll",
    "name": "Name",
    "size": "Size",
    "download": "Download"
  }
} as Record<string, Record<ViewerStringKey, string>>;
